require("!!C:\\Users\\Pedro\\1-KRAFTI\\MMEGA\\PAINEL\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\Pedro\\1-KRAFTI\\MMEGA\\PAINEL\\node_modules\\raw-loader\\index.js!C:\\Users\\Pedro\\1-KRAFTI\\MMEGA\\PAINEL\\node_modules\\source-map-loader\\index.js!C:\\Users\\Pedro\\1-KRAFTI\\MMEGA\\PAINEL\\src\\assets\\js\\core\\jquery.perfect-scrollbar.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/assets/js/core/jquery.perfect-scrollbar.min.js
// module id = 356
// module chunks = 16